import React from 'react'
import { Flex } from 'antd'
import {
  ClientCountWidget,
  VerificationCountWidget,
  KpiWidget,
  BalanceSummaryWidget,
  TransactionCountWidget,
} from './widgets'
import { CCardBody } from '@coreui/react-pro'
import { Guard } from '../../features/session/guard'

export const Dashboard = () => {
  return (
    <CCardBody>
      <Flex gap={16} wrap="wrap">
        <Guard permission="clients_count">
          <ClientCountWidget />
        </Guard>
        <Guard permission="view_verification_badges">
          <VerificationCountWidget />
        </Guard>
        <Guard permission="view_transactions_badges">
          <TransactionCountWidget />
        </Guard>
      </Flex>
      <Flex gap={16} wrap="wrap" style={{ marginTop: 16 }}>
        <Guard permission="view_kpi_income">
          <KpiWidget />
        </Guard>
        <Guard permission="view_fin_statement">
          <BalanceSummaryWidget />
        </Guard>
      </Flex>
    </CCardBody>
  )
}
